import { Component, ViewEncapsulation, OnInit, Input } from '@angular/core';
import { DataCardService } from '../data-card.service';

@Component({
  selector: 'data-card-tbl',
  templateUrl: './data-card-tbl.component.html',
  styleUrls: ['./data-card-tbl.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class DataCardTblComponent {

  changedRowIndex:number;
  @Input() data;

  constructor(private _dataCardService: DataCardService) {
  }

  ngOnInit() {

    this._dataCardService.onIndexChange.subscribe( (v) => {
      this.changedRowIndex = v;
    });
  }

  onRowSelected(index) {
    this._dataCardService.notifyAll(index);
  }
}


// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/data-cards/data-card-tbl/data-card-tbl.component.ts